import { useTranslation } from 'react-i18next'

import { getQaSelectorButton } from '../../../../utils/common'
import { ICON_COLOR, ICON_HEIGHT_24, IconNG } from '../../../Icon'
import Text from '../../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ADD_CARD } from '../../DashboardBirdview.constants.qa'

import * as styles from './BirdviewChartCatalogAddCard.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function BirdviewChartCatalogAddCard({ anchorRef, onClick }) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelectorButton({
        value: QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ADD_CARD,
      })}
      className={styles.card}
      onClick={onClick}
    >
      <div className={styles.label} ref={anchorRef}>
        <IconNG
          Icon={PlusIcon}
          color={ICON_COLOR.CurrentColor}
          size={ICON_HEIGHT_24}
        />
        <Text className={styles.text}>
          {t('DashboardBirdview.ChartCatalogAddChartKey')}
        </Text>
      </div>
    </div>
  )
}

export default BirdviewChartCatalogAddCard
